export default __webpack_public_path__ + "static/media/header-bg.69f02dd9.jpg";